"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 18v-1h1.99L22 3H2v14h2v1H0v2h24v-2zM4 5h16v10H4z"
}), 'LaptopWindowsSharp');